import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const ClickOut = ({ children, onClickOut = () => null }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOut = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClickOut(event);
      }
    };
    document.addEventListener('mousedown', handleClickOut);
    return () => document.removeEventListener('mousedown', handleClickOut);
  }, [onClickOut]);

  return <div ref={wrapperRef}>{children}</div>;
};

ClickOut.propTypes = {
  children: PropTypes.node,
  onClickOut: PropTypes.func,
};

export default ClickOut;



// WEBPACK FOOTER //
// ./src/components/ClickOut/ClickOut.jsx